// @flow
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './styles.module.scss';

type Props = {
  width: number,
  height: number,
};

// The caption strip occupies the bottom 15% of the frame.
const CAPTION_ZONE_RATIO = 0.15;

// Head oval aspect ratio (ry / rx). A natural head is roughly 1.35:1 tall.
const HEAD_ASPECT = 1.35;

// Oval height as a fraction of the usable area (above caption zone).
// Capped so it never looks too large in a short landscape frame.
const OVAL_HEIGHT_RATIO = 0.6;
const OVAL_HEIGHT_MAX_PX = 200;

const FaceGuide = ({ width, height }: Props) => {
  const { formatMessage } = useIntl();

  const captionH = Math.round(height * CAPTION_ZONE_RATIO);
  const usableH = height - captionH;

  // Derive rx/ry from container height so shape stays consistent across sizes.
  const ry = Math.min(Math.round(usableH * OVAL_HEIGHT_RATIO * 0.5), OVAL_HEIGHT_MAX_PX);
  const rx = Math.round(ry / HEAD_ASPECT);

  // Center horizontally; sit in the upper portion of the usable area.
  const cx = Math.round(width / 2);
  const cy = Math.round(usableH * 0.46);

  return (
    <div className={styles.overlay} aria-hidden="true">
      <svg className={styles.svg} viewBox={`0 0 ${width} ${usableH}`} style={{ height: `${usableH}px` }}>
        <ellipse
          cx={cx}
          cy={cy}
          rx={rx}
          ry={ry}
          fill="none"
          stroke="rgba(255,255,255,0.6)"
          strokeWidth="1.5"
          strokeDasharray="6 4"
        />
      </svg>
      <div className={styles.captionZone} style={{ height: captionH }}>
        <span className={styles.captionZoneLabel}>{formatMessage({ id: 'app.video-back.caption-zone' })}</span>
      </div>
    </div>
  );
};

export default FaceGuide;
